import { EventResponse } from '@goldcast/api/backend';

import { getInitialState } from './index';
import {
  State,
  FilterBy,
  SortBy,
  Events,
  Params,
  EventListFilter,
  ListPageType,
  RepeatingEventFilterItemsEnum
} from './types';
import { transformServerEvents } from './utils';

import { PardotList } from '@/studio/eventIntegration/store/types';

const mutations = {
  setEvents(state: State, events: Events) {
    state.events = events;
  },
  updateEvent(state: State, updatedEvent) {
    const eventId = Object.keys(updatedEvent)[0];
    state.events = {
      ...state.events,
      [eventId]: updatedEvent[eventId]
    };
  },
  setSearchTerm(state: State, newSearchTerm: string) {
    state.searchTerm = newSearchTerm;
  },
  setFilterBy(state: State, filterBy: FilterBy) {
    state.filterBy = filterBy;
  },
  setSortBy(state: State, sortBy: SortBy) {
    state.sortBy = sortBy;
  },
  setWorkspaceId(state: State, workspaceId: string) {
    state.workspaceId = workspaceId;
  },
  setRepeatingEventFilter(state: State, repeatingEventFilter: RepeatingEventFilterItemsEnum) {
    state.repeatingEventFilter = repeatingEventFilter;
  },
  toggleSelectedTagId(state: State, tagId: string) {
    if (state.selectedTagIds.includes(tagId)) {
      state.selectedTagIds = state.selectedTagIds.filter(id => id !== tagId);
    } else {
      state.selectedTagIds = [...state.selectedTagIds, tagId];
    }
  },
  clearSelectedTagIds(state: State) {
    state.selectedTagIds = [];
  },
  removeSelectedTagId(state: State, tagId: string) {
    state.selectedTagIds = state.selectedTagIds.filter(id => id !== tagId);
  },
  setEventTypes(state: State, eventTypes: EventListFilter) {
    state.eventTypes = eventTypes;
  },
  resetEventTypes(state: State) {
    state.eventTypes = EventListFilter.AllEvents;
  },
  setIsLoading(state: State, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  setEventsPerPage(state: State, eventsPerPage: number) {
    state.eventsPerPage = eventsPerPage;
  },
  setCurrentPage(state: State, currentPage: number) {
    state.currentPage = currentPage;
  },
  setEventsCount(state: State, eventsCount: number) {
    state.eventsCount = eventsCount;
  },
  setEventDetails(state: State, event: EventResponse) {
    mutations.setCurrentEventID(state, event.id);
    mutations.setEvents(state, transformServerEvents([event]));
  },
  partialUpdateEvent(
    state: State,
    {
      eventId,
      partialEvent
    }: {
      eventId: string;
      partialEvent: Partial<EventResponse>;
    }
  ) {
    state.events[eventId] = {
      ...state.events[eventId],
      ...partialEvent
    };
  },
  setCurrentEventID(state: State, eventId: string) {
    state.currentEventId = eventId;
  },
  setEventListParamsState(state: State, params: Params) {
    state.sortBy = params.sortBy;
    state.filterBy = params.filterBy;
    state.searchTerm = params.searchTerm;
    state.currentPage = params.currentPage;
    state.selectedTagIds = params.tags;
    state.eventTypes = params.eventTypes;
    state.workspaceId = params.workspaceId;
    state.repeatingEventFilter = params.repeatingEventFilter;
  },
  resetEventListState(state: State) {
    Object.assign(state, getInitialState());
  },
  setUpdateEventLoading(state: State, isUpdateEventLoading: boolean) {
    state.isUpdateEventLoading = isUpdateEventLoading;
  },
  setCurrentEventPardotList(state: State, newPardotList: PardotList[]) {
    state.events[state.currentEventId].pardot_list = newPardotList;
  },
  setIsIntegrationTemplateDataLoadingAndUpdatingEvent(state: State, isIntegrationTemplateDataLoading: boolean) {
    state.isIntegrationTemplateDataLoadingAndUpdatingEvent = isIntegrationTemplateDataLoading;
  },
  setLastOpenedPage(state: State, lastOpenedPage: ListPageType) {
    state.lastOpenedPage = lastOpenedPage;
  }
};

export default mutations;
